import { render, staticRenderFns } from "./RelatedCategoryItem.vue?vue&type=template&id=532c0845"
import script from "./RelatedCategoryItem.vue?vue&type=script&lang=ts"
export * from "./RelatedCategoryItem.vue?vue&type=script&lang=ts"
import style0 from "./RelatedCategoryItem.vue?vue&type=style&index=0&id=532c0845&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports